import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MenuItems from "./MenuItems";

import Logo from "../../assets/img/logo/logo-white-5.png";
import LogoBlack from "../../assets/img/logo/logo-black-2.png";
import LogoWhite from "../../assets/img/logo/logo-white-2.png";

const HeaderSeven = (props) => {
  const { headerClass, headerLogo } = props;
  const [isOffCanvasOpen, setIsOffCanvasOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isPopUpOpen, setIsPopUpOpen] = useState(false);

  useEffect(() => {
    // Sticky Header is displayed after scrolling for 400 pixels
    const toggleVisibility = () => {
      if (window.scrollY > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <>
      <div
        className={
          isPopUpOpen ? "search__popup search-opened" : "search__popup"
        }
      >
        <div className="container">
          <div className="row">
            <div className="col-xxl-12">
              <div className="search__wrapper">
                <div className="search__top d-flex justify-content-between align-items-center">
                  <div className="search__logo">
                    <Link to="/">
                      <img src={LogoBlack} alt="" />
                    </Link>
                  </div>
                  <div className="search__close">
                    <button
                      type="button"
                      className="search__close-btn search-close-btn"
                      onClick={() => setIsPopUpOpen(false)}
                    >
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 1L1 17"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M1 1L17 17"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
                <div className="search__form">
                  <form action="#">
                    <div className="search__input">
                      <input
                        className="search-input-field"
                        type="text"
                        placeholder="Type here to search..."
                      />
                      <span className="search-focus-border"></span>
                      <button type="submit">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.55 18.1C14.272 18.1 18.1 14.272 18.1 9.55C18.1 4.82797 14.272 1 9.55 1C4.82797 1 1 4.82797 1 9.55C1 14.272 4.82797 18.1 9.55 18.1Z"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M19.0002 19.0002L17.2002 17.2002"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <header className={headerClass ? headerClass : "header-height"}>
        <div
          id="header-sticky"
          className={
            isVisible
              ? "it-header-2-area it-header-inner-style z-index-5 header-sticky"
              : "it-header-2-area it-header-inner-style z-index-5"
          }
        >
          <div className="it-main-logo">
            <Link to="/">
              <img src={headerLogo ? headerLogo : Logo} alt="" />
            </Link>
          </div>

          <div className="it-header-2-pl">
            <div className="it-header-2-top black-bg it-header-2-space-lr">
              <div className="container-fluid">
                <div className="row align-items-center">
                  <div className="col-xl-8 col-lg-6 col-md-6">
                    <div className="it-header-2-top-info">
                      <ul>
                        <li className="d-none d-xl-inline-block">
                          <i className="flaticon-phone-call"></i>
                          <a
                            className="hover-anim white"
                            href="tel:(00)8757845682"
                          >
                            (615) xxx-xxxx
                          </a>
                        </li>
                        <li>
                          <i className="flaticon-letter"></i>
                          <a
                            className="hover-anim white"
                            href="mailto:Insurinfo@gmail.com"
                          >
                            Information@greenhillwellnessmj.com
                          </a>
                        </li>
                        <li className="d-none d-xl-inline-block">
                          <i className="flaticon-location"></i>
                          <a
                            className="hover-anim white"
                            href="https://www.google.com/maps/@23.7912408,90.5848486,11.67z?entry=ttu"
                            target="_blank"
                          >
                            Lebanon Rd, Old Hickory, TN 37122.
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-6 col-md-6 d-none d-md-block">
                    <div className="it-header-2-top-right text-end">
                      <div className="it-header-2-top-social">
                        <a href="#">
                          <i className="fab fa-facebook-f"></i>
                        </a>
                        <a href="#">
                          <i className="fab fa-twitter"></i>
                        </a>
                        <a href="#">
                          <i className="fab fa-skype"></i>
                        </a>
                        <a href="#">
                          <i className="fab fa-linkedin"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="it-header-2-area it-header-2-space-lr white-bg it-header-2-mob-space">
              <div className="container-fluid">
                <div className="row align-items-center">
                  <div className="col-xl-10 d-none d-xl-block">
                    <div className="it-header-main-menu it-main-menu">
                      <nav className="it-menu-content">
                        <MenuItems />
                      </nav>
                    </div>
                  </div>
                  <div className="col-6 d-md-none">
                    <div className="it-header-logo">
                      <Link tp="/">
                        <img src={LogoBlack} alt="" />
                      </Link>
                    </div>
                  </div>
                  <div className="col-xl-2 col-lg-12 col-md-12  col-6">
                    <div className="it-header-2-right-box d-flex align-items-center justify-content-end">
                      <div className="it-header-2-right-search d-none d-sm-block">
                        <button
                          className="search-open-btn"
                          onClick={() => setIsPopUpOpen(true)}
                        >
                          <i className="fa-sharp fa-light fa-magnifying-glass"></i>
                        </button>
                      </div>
                      <div className="it-header-2-right-user d-none d-md-block">
                        <Link to="/login">
                          <i className="fa-solid fa-user"></i>
                        </Link>
                      </div>
                      <div className="it-header-bar d-xl-none">
                        <button
                          className="it-menu-bar"
                          onClick={() => setIsOffCanvasOpen(true)}
                        >
                          <span>
                            <i className="fa-regular fa-bars-sort"></i>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="it-offcanvas-area">
        <div className={isOffCanvasOpen ? "itoffcanvas opened" : "itoffcanvas"}>
          <div className="itoffcanvas__close-btn">
            <button
              className="close-btn"
              onClick={() => setIsOffCanvasOpen(false)}
            >
              <i className="fal fa-times"></i>
            </button>
          </div>
          <div className="itoffcanvas__logo">
            <Link to="/">
              <img src={LogoWhite} alt="" />
            </Link>
          </div>
          <div className="itoffcanvas__text">
            <p>
              Suspendisse interdum consectetur libero id. Fermentum leo vel orci
              porta non. Euismod viverra nibh cras pulvinar suspen.
            </p>
          </div>
          <div className="it-menu-mobile">
            <MenuItems isMobileMenu />
          </div>
          <div className="itoffcanvas__info">
            <h3 className="offcanva-title">Get In Touch</h3>
            <div className="it-info-wrapper mb-20 d-flex align-items-center">
              <div className="itoffcanvas__info-icon">
                <a href="#">
                  <i className="fal fa-envelope"></i>
                </a>
              </div>
              <div className="itoffcanvas__info-address">
                <span>Email</span>
                <a href="maito:hello@yourmail.com">hello@yourmail.com</a>
              </div>
            </div>
            <div className="it-info-wrapper mb-20 d-flex align-items-center">
              <div className="itoffcanvas__info-icon">
                <a href="#">
                  <i className="fal fa-phone-alt"></i>
                </a>
              </div>
              <div className="itoffcanvas__info-address">
                <span>Phone</span>
                <a href="tel:(00)45611227890">(00) 456 1122 7890</a>
              </div>
            </div>
            <div className="it-info-wrapper mb-20 d-flex align-items-center">
              <div className="itoffcanvas__info-icon">
                <a href="#">
                  <i className="fas fa-map-marker-alt"></i>
                </a>
              </div>
              <div className="itoffcanvas__info-address">
                <span>Location</span>
                <a
                  href="htits://www.google.com/maps/@37.4801311,22.8928877,3z"
                  target="_blank"
                >
                  Riverside 255, San Francisco, USA
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isOffCanvasOpen ? (
        <div
          className="body-overlay apply"
          onClick={() => setIsOffCanvasOpen(false)}
        ></div>
      ) : (
        <div className="body-overlay"></div>
      )}
    </>
  );
};

export default HeaderSeven;
